@switch (inputItem!.type) {
	@case ('text') {
		<label
			[for]="inputItem.id"
			class="form-label"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<input
			type="text"
			[id]="inputItem.id"
			class="form-control"
			[formControlName]="inputItem.id"
			[placeholder]="inputItem.placeholder"
			(input)="onInputChange($event, inputItem)"
		/>
	}
	@case ('text-no-label') {
		<input
			type="text"
			[id]="inputItem.id"
			class="form-control"
			[formControlName]="inputItem.id"
			[placeholder]="inputItem.placeholder"
		/>
	}
	@case ('password') {
		<label
			[for]="inputItem.id"
			class="form-label"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<div class="password-wrap">
			<input
				[type]="showPassword() ? 'text' : 'password'"
				[id]="inputItem.id"
				class="form-control"
				[formControlName]="inputItem.id"
				[placeholder]="inputItem.placeholder"
			/>
			<div
				id="show-password"
				(click)="showPassword.set(!showPassword())"
			>
				<i
					[class]="showPassword() ? 'bi bi-eye' : 'bi bi-eye-slash'"
					alt="Toogle Password"
					[title]="showPassword() ? 'Nascondi password' : 'Mostra password'"
				>
				</i>
			</div>
		</div>
	}
	@case ('email') {
		<label
			[for]="inputItem.id"
			class="form-label"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<input
			type="email"
			[id]="inputItem.id"
			class="form-control"
			[formControlName]="inputItem.id"
			[placeholder]="inputItem.placeholder"
		/>
	}
	@case ('select') {
		<label
			[for]="inputItem.id"
			class="form-label"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<select
			[id]="inputItem.id"
			[formControlName]="inputItem.id"
			class="form-select"
		>
			<option
				value=""
				selected
			>
				{{ inputItem.placeholder }}
			</option>
			@for (option of inputItem.data; track option.id) {
				<option [value]="option.id">{{ option.name | capitalFirst }}</option>
			}
		</select>
	}
	@case ('textarea') {
		<label
			[for]="inputItem.id"
			class="form-label"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<textarea
			[id]="inputItem.id"
			[formControlName]="inputItem.id"
			class="form-control"
			rows="3"
			[placeholder]="inputItem.placeholder"
		></textarea>
	}
	@case ('date') {
		<label
			[for]="inputItem.id"
			class="form-label"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<div class="d-flex">
			<input
				type="text"
				[id]="inputItem.id"
				[formControlName]="inputItem.id"
				class="form-control date-picker bg-light-ks rounded-3 rounded-end-0"
				placeholder="dd/mm/yyyy"
				appDatepicker
				[formControl]="$any(formGroup.get(inputItem.id))"
				[attr.aria-label]="inputItem.label"
			/>
			<span class="input-group-text date-picker-calendar-span rounded-3 rounded-start-0"><i class="bi bi-calendar"></i></span>
		</div>
	}
	@case ('hidden') {
		<input
			type="hidden"
			class="form-control"
			[formControlName]="inputItem.id"
			value="0"
		/>
	}
	@case ('color-picker') {
		<label
			[for]="inputItem.id"
			class="form-label"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<div class="input-group">
			<span class="input-group-text color-picker-span">{{ displayColorValue }}</span>
			<input
				type="color"
				class="form-control form-control-color"
				#colorPicker
				[id]="inputItem.id"
				[formControlName]="inputItem.id"
				(change)="updateColorDisplay($event)"
				(input)="updateColorDisplay($event)"
				value=""
			/>
		</div>
	}
	@case ('single-checkbox') {
		<label
			[for]="inputItem.id"
			class="form-label d-block"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<input
			type="checkbox"
			class="form-check-input checkbox-large"
			[id]="inputItem.id"
			[formControlName]="inputItem.id"
		/>
	}
	@case ('plain-checkbox') {
		<div class="d-flex align-items-start checkbox-wrapper">
			<input
				type="checkbox"
				class="form-check-input checkbox-align"
				[id]="inputItem.id"
				[formControlName]="inputItem.id"
			/>
			<label
				[for]="inputItem.id"
				class="text-left-label"
				[innerHTML]="inputItem.label"
				[class.required-asterisk]="isRequired(inputItem.id)"
			>
				{{ inputItem.label }}
			</label>
		</div>
	}
	@case ('number') {
		<label
			[for]="inputItem.id"
			class="form-label"
			[class.required-asterisk]="isRequired(inputItem.id)"
		>
			{{ inputItem.label }}
		</label>
		<input
			type="number"
			[id]="inputItem.id"
			class="form-control"
			[formControlName]="inputItem.id"
			[placeholder]="inputItem.placeholder"
		/>
	}
	@case('ng-select') {
    <label
        [for]="inputItem.id"
        class="form-label"
        [class.required-asterisk]="isRequired(inputItem.id)"
    >
        {{ inputItem.label }}
    </label>
    <ng-select
        [items]="inputItem.data"
        [placeholder]="inputItem.placeholder"
        [formControlName]="inputItem.id"
        [searchable]="true"
        [clearable]="true"
        bindValue="id"
        bindLabel="name"
        notFoundText="Nessun elemento trovato"
        class="w-100 form-ng-select"
        [virtualScroll]="true"
    >
    </ng-select>
}
}
@for (error of getFieldErrors(inputItem.id); track $index) {
	<div class="invalid-feedback d-block">
		{{ error }}
	</div>
}
